<template>
    <common-page card-content>
        <query-view ref="jscList" :config-code="$_configCode"
                    :filter="filter"
                    custom-columns="id"
                    disable-export enable-edit
                    :disable-edit-btn="2"
                    with-custom-actions-head-of-row>
            <template #leftHeader>
                <mini-button name="add#" @btnClick="openEdit(null)">
                    <i class="fa-solid fa-plus"></i>
                </mini-button>
                <mini-button @btnClick="importConfigs">Import</mini-button>
                <mini-button :disable="$_notChecked" @btnClick="copyConfigs">Export/Copy</mini-button>
            </template>
            <template #custom(id)="{row}">
                <IdRecode v-if="row.id" class="mr-1" :id="row.id" :service="row.moduleCode" :code-config="codeIdMap"/>
            </template>
            <template #headOfRow="{row}">
                <mini-button name="edit#" @btnClick="openEdit(row)">
                    <i class="fa-solid fa-pen-to-square"></i>
                </mini-button>
            </template>
        </query-view>

        <template #outer>
            <re-b-modal ref="jsonInput" header="粘贴配置"
                        :no-ok-button="coping"
                        @ok="parseConfigJson(copiedJsonStr)"
                        @hide="copiedJsonStr=null;coping=false;">
                <mini-input type="textarea" class="m-auto"
                            :value.sync="copiedJsonStr"
                            without-label></mini-input>
            </re-b-modal>
            <re-b-modal ref="jsonView" header="JSON查看" ok-label="上传" @ok="uploadJson">
                <vue-json-pretty :data="copiedJson" :deep="5"></vue-json-pretty>
            </re-b-modal>

            <re-b-modal ref="configModal" super-large hide-footer hide-header>
                <query-config ref="queryConfig" single-mode style="min-height: 400px"
                              @saved="$refs.jscList.queryRows()"></query-config>
            </re-b-modal>
        </template>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import QueryView from "@/components/common/display/query-view/QueryView.vue";
import IdRecode from "@/components/jsc/qc-cell/stuff/IdRecode.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import miniTableCheckedMixin from "@/mixin/em/common/stuffs/table/miniTableCheckedMixin";
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import VueJsonPretty from 'vue-json-pretty';
import QueryConfig from "@/components/jsc/QueryConfig.vue";
import {DICT_TYPE} from "@/plugins/configure-query-helper";

export default {
    name: "QCTablePage",
    components: {QueryConfig, ReBModal, MiniInput, MiniButton, IdRecode, QueryView, CommonPage, VueJsonPretty},
    mixins: [miniTableCheckedMixin],
    data() {
        return {
            filter: {
                identifyCode: 'query-config',
            },
            copiedJsonStr: null,
            copiedJson: null,
            coping: false,

            codeIdMap: [],
        }
    },
    computed: {
        $_configCode() {
            return "jsc";
        },
    },
    mounted() {
        this.queryCodeIdMap();
    },
    methods: {
        //-------------------------------------------
        copyConfigs() {
            if (this.$_notChecked) {
                this.$message.warning('You should select first');
                return;
            }
            let json = JSON.stringify(this.checkedRows);
            if (navigator.clipboard) {
                navigator.clipboard.writeText(json);
                this.$message.success("Copied");
            } else {
                this.copiedJsonStr = json;
                this.coping = true;
                this.$refs.jsonInput.showModal();
            }
        },
        importConfigs() {
            if (navigator.clipboard) {
                navigator.clipboard.readText().then(json => {
                    this.parseConfigJson(json);
                });
            } else {
                this.$refs.jsonInput.showModal();
            }
        },
        parseConfigJson(json) {
            try {
                this.copiedJson = JSON.parse(json);
                this.$refs.jsonView.showModal();
            } catch (error) {
                this.$message.error('拷贝内容格式错误：' + error);
            }
        },
        uploadJson() {
            this.$store.dispatch('api/post', {
                url: `${process.env.VUE_APP_EM_ASSISTANT_URL}/jscConfiguration/upload/copied`,
                data: this.copiedJson
            }).then(() => {
                this.$message.success("Upload success");
                this.$refs.jscList.queryRows();
                this.copiedJson = null;
            });
        },
        //-------------------------------------------
        openEdit(config) {
            this.$refs.configModal.showModal();
            this.$nextTick(() => this.$refs.queryConfig.load(config));
        },
        //-------------------------------------------
        queryCodeIdMap() {
            this.$store.dispatch('dictionaryEnumStore/getDictOriginal', DICT_TYPE)
                .then(res => {
                    this.codeIdMap = res;
                });
        },
        //-------------------------------------------
    }
}
</script>

<style scoped>

</style>
